import { render, staticRenderFns } from "./TableCollapseServices.vue?vue&type=template&id=c339cb84&scoped=true"
import script from "./TableCollapseServices.vue?vue&type=script&lang=js"
export * from "./TableCollapseServices.vue?vue&type=script&lang=js"
import style0 from "./TableCollapseServices.vue?vue&type=style&index=0&id=c339cb84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c339cb84",
  null
  
)

export default component.exports